import axios from 'axios';
import { API_HOST } from '../constants/constants';
export const getContacts = async (listId,exclude=false, contactId = null, token, userID) => {
  const apiURL = API_HOST +
     (
        contactId
        ?
        '/contacts/'+contactId
        :
        listId
        ?
        '/contacts?listID='+listId+'&exclude='+exclude
        :
        '/contacts'
     );
  try {
    const { data } = await axios.get(apiURL,{
      headers: {
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
